"use client";
import React, { useState } from "react";
import Header from "./Header";

import ClaimReward from "./ClaimReward";
import Unstake from "./Unstake";
import EarnedRewards from "./EarnedRewards";
import StakedBal from "./StakedBal";

import { Card, CardTitle } from "./shared/Card";
import Stake from "./Stake";
import SupplyChart from "./Chart";
import { Connect } from "./Connect";
import { useAccount, useContractRead } from "wagmi";
import { abiToken } from "./erc20";

const Staking = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { isConnected } = useAccount();
  // const { address } = useAccount();

  // const { data: stackingInfo } = useContractRead({
  //   address: `0x${process.env.REACT_APP_TOKEN_ADDRESS}`,
  //   abi: abiToken,
  //   functionName: "stakers",
  //   args: [address],
  // });
  return (
    <div>
      <div className="h-screen pb-10">
        <div className="sticky mb-10">
          <Header />
        </div>
        <div
          className="
          flex
          items-end
          px-5
          flex-row
          justify-between
          max-md:flex-col
          max-md:items-start
         "
        >
          <div className="w-[60%] max-md:w-full">
            <h1
              style={{
                background:
                  "linear-gradient(to right, rgb(0, 174, 239) 0%, rgb(140, 199, 59) 100%)",
                display: "inline",
                WebkitTextFillColor: "transparent",
                WebkitBackgroundClip: "text",
              }}
              className="text-[30px] uppercase max-w-[500px] font-[800] sm:text-[50px]"
            >
              Welcome to $TUK TOKENS
            </h1>
            <p className="text-[#fff] w-full text-justify sm:mb-0 mb-[20px]">
              $TUK Token rewards will be distributed to users at a rate of 4.75
              $TUK per BSC block. Rewards will be payable over 3 years and are
              determined by your share of the staking pool and annual returns
              percentage.
            </p>
          </div>
          <div className="max-sm:w-full min-w-fit">
            <Unstake />
          </div>
        </div>
        <div
          className=" text-[#fff] block 
        sm:grid grid-cols-3 md:grid-cols-4
         lg:grid-cols-5 gap-[20px] mx-5
           sm:mx-[20px]  mt-[50px]"
        >
          <Card>
            <CardTitle>STAKED BALANCE</CardTitle>
            <h1 className="text-[#29a9e0] my-[8px] font-[700] text-[30px]">
              <StakedBal /> <sup className="text-[16px] text-[#fff]">$TUK</sup>
            </h1>
            <h1 className="text-[14px] mb-[4px]">YOUR STAKEABLE</h1>
            <h1 className="text-[#29a9e0] my-[8px] font-[700] text-[30px]">
              0 <sup className="text-[16px] text-[#fff]">$TUK</sup>
            </h1>
            <div className="text-center flex flex-col items-center">
              {isConnected ? (
                <button
                  onClick={() => setIsOpen(true)}
                  className="text-center border-[2px] border-[#ffd400] rounded-3xl p-[10px_12px] w-full"
                >
                  STAKE
                </button>
              ) : (
                <Connect className="w-full justify-stretch" text="STAKE" />
              )}
            </div>
          </Card>
          <Card className="justify-start">
            <CardTitle>% OF POOL</CardTitle>
            <h1 className="my-[8px] text-[30px] font-[700]">0%</h1>
            <h1 className="text-[14px] mb-[4px] tracking-[1.4px]">
              TOTAL STAKED
            </h1>
            <h1 className="text-[#29a9e0] my-[8px] font-[700] text-[20px] xl:text-[30px]">
              28,299,213<sup className="text-[16px] text-[#fff]">$TUK</sup>
            </h1>
          </Card>
          <Card>
            <div>
              <CardTitle>ESTIMATED REWARDS</CardTitle>
              <h1 className="text-[14px] mb-[4px] "></h1>
              <h1 className=" my-[8px] font-[700] text-[30px]">
                177% <sup className="text-[16px] text-[#fff]">p/a</sup>
              </h1>
            </div>
            <div className="text-[12px] font-[500]">
              <p>Returns = Annual Returns Percentage</p>
              <p>Monthly = Returns / 12</p>
              <p>Daily = Returns / 365</p>
            </div>
          </Card>
          <Card className="justify-start">
            <CardTitle>CURRENT REWARDS</CardTitle>
            <div className="flex flex-row my-[8px]">
              <h1 className="text-[#29a9e0] font-[700] text-[30px]">4.75 </h1>
              <span className="text-[16px] text-[#fff] text-wrap">
                Per BSC Block
              </span>
            </div>
          </Card>
          <Card>
            <div>
              <CardTitle>TOTAL REWARDS</CardTitle>
              <h1 className="text-[#29a9e0] my-[8px] font-[700] text-[30px]">
                <EarnedRewards />
                <sup className="text-[16px] text-[#fff]">$TUK</sup>
              </h1>
            </div>
            <div className="w-full text-center">
              {isConnected ? (
                <ClaimReward />
              ) : (
                <Connect
                  className="w-full justify-stretch"
                  text="CLAIM REWARDS"
                />
              )}
            </div>
          </Card>
        </div>
        <div className="flex flex-wrap justify-center items-center lg:justify-between ">
          <SupplyChart />
          <img src="/logo.png" alt="logo" className="max-lg:mt-5" />
          <div></div>
        </div>
      </div>
      <Stake open={isOpen} onClose={() => setIsOpen(false)} />
    </div>
  );
};

export default Staking;
